module.exports = __webpack_public_path__ + "img/icon-goal-2.3a1722ff.svg";